import { createFileRoute } from "@tanstack/react-router";
import { PurchaseAnalysisNewOrdersPage } from "@/features/reports/purchase-analysis-new-orders-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/analiza-zakupow-nowe-zam")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.analiza-zakupow-nowe-zam",
			location.pathname,
		);
	},
	component: PurchaseAnalysisNewOrdersPage,
});
